import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint } from '@confluence/loadable';

export const ReadingAidsAcronymsHighlighter: LoadableType<{
	contentId: string;
}> = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-readingAidsAcronymsHighlighter" */ '../src/ReadingAidsAcronymsHighlighter.tsx'
			)
		).ReadingAidsAcronymsHighlighter,
});
